import { CaptchaService } from './../services/captcha/captcha.service'; 
import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';
import { LoggerApiService } from '../services/logger/logger-api.service';
import { StorageService } from '../services/Storage/storage.service';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnInit, OnDestroy {
  public recaptcha: any = null;

   @ViewChild('captchaElem', {static: true}) captchaElem: InvisibleReCaptchaComponent;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;
  public site_key: string;

  private captchaExe$: Subscription;
  private captchaReset$: Subscription;

  // private isInited = false;
  // private intervalObject;
  // private intervalCount = 0;
  constructor(
    private cdr: ChangeDetectorRef,
    private captchaService: CaptchaService,
    private loaderService: LoaderService,
    private storage: StorageService,
    private loggerApi: LoggerApiService
  ) { }
  ngOnInit() {
    this.site_key = environment.site_key;
    this.captchaExe$ = this.captchaService.captchaExeSubscribe.subscribe(() => {
      if (this.captchaIsReady) {
          this.execute();
      } else {
        this.loaderService.changeLoaderState(false);
        alert('שגיאת recaptcha.');
        console.log('captcha is not ready and will not execute');
      }
    });
    this.captchaReset$ = this.captchaService.captchaResetSubscribe.subscribe(() => {
      this.reset();
    });
    //  this.handleReset();
    //  this.handleLoad();
  }
  handleReset(): void {
    console.log('handleReset');
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.cdr.detectChanges();
    this.captchaService.reset();
  }

  // handleSuccess(captchaResponse: string): void {
    handleSuccess(ev: any): void {
    console.log('handleSuccess: ' + ev);
    this.captchaSuccess = true;
    this.captchaResponse = ev;
    this.cdr.detectChanges();
    // this.captchaService.setToken(captchaResponse);

    this.captchaService.handleCaptchaRes(true, ev);

    // if (!this.isInited) {
    //   this.isInited = true;
    //   this.intervalObject = setInterval(() => {
    //     this.intervalCount++;
    //     if (this.intervalCount > 3) {
    //       this.handleReset();
    //       this.intervalCount = 0;
    //     }
    //     this.execute();
    //   }, 180000)
    // }
  }
  handleError(ev: any): void {
    // Log captcha error
    this.loggerApi.sendEventLog({
      event: 'captcha_error',
      data: ev,
      timestamp: new Date(),
      url: window.location.href,
      token: this.storage.getToken()
    });
    console.log('captcha error', ev);
    this.handleReset();
    this.handleReady();
  }
  handleLoad(): void {
    console.log('handleLoad');
    this.captchaIsLoaded = true;
    this.cdr.detectChanges();

  }

  handleReady(): void {
    console.log('handleReady');
    this.captchaIsReady = true;
    this.cdr.detectChanges();
   // this.execute();
  }
  execute(): void {
    if (this.captchaElem) {
      console.log('execute');
        this.captchaElem.execute();
    } else {
      console.log('captchaElem does not exist');
    }
  }
  getResponse(): void {
    console.log('getResponse');
    const response = this.captchaElem.getResponse();
    if (!response) {
      alert(`There is no response from grecaptcha script - try using 'getCurrentResponse' method or subscribe to 'success' event`);
    } else {
      alert(response);
      this.captchaService.setToken(response);
    }
  }

  reload(): void {
    console.log('reload');
    this.captchaElem.reloadCaptcha();
  }

  getCaptchaId(): void {
    console.log('getCaptchaId');
    alert(this.captchaElem.getCaptchaId());
  }

  reset(): void {
    console.log('reset');
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaElem.resetCaptcha();
  }

  getCurrentResponse(): void {
    console.log('getCurrentResponse');
    const currentResponse = this.captchaElem.getCurrentResponse();
    if (!currentResponse) {
      alert('There is no current response - have you submitted captcha?');
    } else {
      alert(currentResponse);
    }
  }

  ngOnDestroy() {
    if (this.captchaExe$) {
      this.captchaExe$.unsubscribe();
    }
    if (this.captchaReset$) {
      this.captchaReset$.unsubscribe();
    }
  }
  handleExpire(ev: any) {
    // Log captcha expired
    this.loggerApi.sendEventLog({
      event: 'captcha_expired',
      data: ev,
      timestamp: new Date(),
      url: window.location.href,
      token: this.storage.getToken()
    });
    console.log('captcha expired', ev);
    this.captchaService.handleCaptchaRes(false, '');

    this.reload();
  }
}
